import { Link } from 'react-router-dom';
import { useAdminAccess } from '../lib/useAdminAccess.jsx';
import { useAuth } from '../lib/useAuth.jsx';
import './AdminCommunityPicker.css';

// Community picker — shown when a signed-in admin manages more
// than one community. (Common case for regional ops folks.)
//
// If they only admin one community, they're routed directly to its
// roster from the login redirect logic. If they admin none, they
// see AdminNoAccess.
export default function AdminCommunityPicker() {
  const { communities } = useAdminAccess();
  const { user, logout } = useAuth();

  return (
    <div className="container admin-picker">
      <div className="picker-bar fade-in-1">
        <span className="eyebrow">Choose a Community</span>
        <button type="button" className="picker-logout" onClick={logout}>
          Signed in as {user?.email} · Sign out
        </button>
      </div>

      <h1 className="picker-title fade-in-2">
        Which community are you <em>working with</em>?
      </h1>

      <p className="picker-lede fade-in-3">
        You're listed as an administrator for the following
        communities. Pick one to view its residents.
      </p>

      <ul className="picker-list fade-in-4">
        {communities.map((c) => (
          <li key={c.code} className="picker-item">
            <Link
              to={`/admin/communities/${encodeURIComponent(c.code)}/residents`}
              className="picker-link"
            >
              <span className="picker-link-name">{c.name}</span>
              <span className="picker-link-arrow" aria-hidden="true">→</span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
